import http from './http-common';

class CouponService {
  // Get all coupons
  getAllCoupons() {
    return http.get<any>('coupon/admin');
  }

  // Get coupon by ID
  getCoupon(couponId: number) {
    return http.get(`coupon/admin/${couponId}`);
  }

  // Get coupon by code
  getCouponByCode(couponCode: string) {
    return http.get(`coupon/admin/code/${couponCode}`);
  }

  // Create new coupon
  createCoupon(data: any) {
    console.log('CouponService.createCoupon - Data being sent:', data);
    console.log('CouponService.createCoupon - Making POST request to: coupon/admin');
    return http.post('coupon/admin', data);
  }

  // Update existing coupon
  updateCoupon(couponId: number, data: any) {
    return http.put(`coupon/admin/${couponId}`, data);
  }

  // Delete coupon
  removeCoupon(couponId: number) {
    return http.delete(`coupon/admin/${couponId}`);
  }

  // Toggle coupon status (active/inactive)
  toggleCouponStatus(couponId: number) {
    return http.patch(`coupon/admin/${couponId}/toggle-status`);
  }

  // Get all active coupons
  getActiveCoupons() {
    return http.get('coupon/admin/active');
  }

  // Get all expired coupons
  getExpiredCoupons() {
    return http.get('coupon/admin/expired');
  }

  // Get usage statistics for a coupon
  getCouponUsageStats(couponId: number) {
    return http.get(`coupon/admin/${couponId}/usage-stats`);
  }

  // Recalculate usage count for a coupon
  recalculateUsage(couponId: number) {
    return http.get(`coupon/admin/${couponId}/usage-stats`);
  }
}

export default new CouponService();